// ReportBuilder.jsx

import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { Grid, Skeleton, Stack, Tab, Tabs, Typography } from "@mui/material";

import {
    GROUP_COUNTRIES,
    GROUP_OFFERS,
    GROUP_ROOM,
    GROUP_DATE_DAY,
    GROUP_DATE_MONTH,
    GROUP_DATE_YEAR,
    process_,
    // GROUP_TYPE,
    GROUP_VOUCHERS,
    DISPLAY_ELEMENT_HELPER,
} from "../../../helpers/filters";
import Colours from "../../../helpers/colours";

import ReportChartBarOrLines, {
    REPORT_CHART_BARS,
    REPORT_CHART_LINES,
} from "./ReportChartBarOrLines";
import ReportTableMetricsSummary, {
    REPORT_TABLE_METRICS_SUMMARY,
} from "./ReportTableMetricsSummary";
import ReportChartBarsCategory, {
    REPORT_CHART_BARS_CATEGORY,
} from "./ReportChartBarsCategory";
import ActiveFiltersLine from "./ActiveFiltersLine";
import ReportTableOverview, {
    REPORT_TABLE_OVERVIEW,
} from "./ReportTableOverview";
import ReportChartWorldMap, {
    REPORT_CHART_WORLD_MAP,
} from "./ReportChartWorldMap";
import { CheckHideBool } from "../CheckHide";
import ReportTableOverviewYearMonth, {
    REPORT_TABLE_OVERVIEW_YEAR_MONTH,
} from "./ReportTableOverviewYearMonth";
import ReportChartTrendDailyWeeklyMonthly, {
    REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
} from "./ReportChartTrendDailyWeeklyMonthly";
import ReportTableReservations, {
    REPORT_TABLE_RESERVATIONS,
} from "./ReportTableReservations";
import ReportChartInTable, {
    REPORT_CHART_IN_TABLE,
} from "./ReportChartInTable";
import ReportHeatMapCalendar, {
    REPORT_CHART_HEATMAP_CALENDAR,
} from "./ReportHeatMapCalendar";
import ReportChartPerformanceVS, {
    REPORT_CHART_PERFORMANCE_VS,
} from "./ReportChartPerformanceVS";
import ReportPieChart, { REPORT_PIE_CHART } from "./ReportPieChart";
import ReportChartCategoryStacked, {
    REPORT_CHART_CATEGORY_STACKED,
} from "./ReportChartCategoryStacked";
import ReportDayOfTheWeekTable, {
    REPORT_DAY_OF_THE_WEEK_TABLE,
} from "./ReportDayOfTheWeekTable";
import ReportWeekdayWeekend, {
    REPORT_WEEKDAY_WEEKEND,
} from "./ReportWeekdayWeekend";
import ReportPiesDistributionByRate, {
    REPORT_PIES_DISTRIBUTION_BY_RATE,
} from "./ReportPiesDistributionByRate";
import ReportWeekdayRates, { REPORT_WEEKDAY_RATES } from "./ReportWeekdayRates";
import ReportPieMidweekVsWeekend, {
    REPORT_PIE_MIDWEEK_VS_WEEKEND,
} from "./ReportPieMidweekVsWeekend";
import ReportMetricVSMetricBars, {
    REPORT_METRIC_VS_METRIC_BARS,
} from "./ReportMetricVSMetricBars";
import ReportMetricPie, { REPORT_METRIC_PIE } from "./ReportMetricPie";
import ReportMetricLineTrend, {
    REPORT_METRIC_LINE_TREND,
} from "./ReportMetricLineTrend";
import ReportTopDatesTable, {
    REPORT_TOP_DATES_TABLE,
} from "./ReportTopDatesTable";
import ReportHotelSummaryTable, {
    REPORT_HOTEL_SUMMARY_TABLE,
} from "../../reports/ReportHotelSummaryTable";

export const ACTIVE_FILTERS_LINE = "ACTIVE_FILTERS_LINE";
export const BREAK_LINE = "BREAK_LINE";
export const CUSTOM = "CUSTOM";
export const GRID_HORIZONTAL = "GRID_HORIZONTAL"; // xs=1 / sm=2 / md and forward=3
export const TABS = "TABS";
export const TAB = "TAB";

// EXAMPLE FILTERS
// filters: {
//     Countries: [],
//     Offers: [],
//     Rooms: [],
//     Types: [],
//     Extras: [],
//     VoucherNames: [],
// },

// TODO: Come back to this implementation

// const fields_ChartMap = {
//     fieldsOrder: ["bookingsNotCancelled", "roomNightsTotal", "revenueRoom"],
//     hideFields: [
//         ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
//             (e) =>
//                 ![
//                     "bookingsNotCancelled",
//                     "roomNightsTotal",
//                     "revenueRoom",
//                 ].includes(e)
//         ),
//     ],
// };

export const fields_Commission = {
    fieldsOrder: [
        "commissionNotCancelled",
        // "commissionCancelled",
        // "commissionTotal",
        "commissionRoomsNotCancelled",
        // "commissionRoomsCancelled",
        // "commissionRoomsTotal",
        "commissionVouchers",
        // "commissionPercentageFromVouchers",
        // "commissionPercentageFromRooms",
    ],
    hideFields: [
        ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
            (e) =>
                ![
                    "commissionNotCancelled",
                    // "commissionCancelled",
                    // "commissionTotal",
                    "commissionRoomsNotCancelled",
                    // "commissionRoomsCancelled",
                    // "commissionRoomsTotal",
                    "commissionVouchers",
                    // "commissionPercentageFromVouchers",
                    // "commissionPercentageFromRooms",
                ].includes(e),
        ),
    ],
};

export const fields_OverviewTable = {
    fieldsOrder: [
        "bookingsRooms",
        "roomNightsTotal",
        "revenueRoom",
        "ADRTotal",
        "ALoSTotal",
        "ABWTotal",
        "BWTotal",
        "revenueExtras",
        // "bookingsCancelled",
    ],
    hideFields: [
        ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
            (e) =>
                ![
                    "bookingsRooms",
                    "roomNightsTotal",
                    "revenueRoom",
                    "ADRTotal",
                    "ALoSTotal",
                    "ABWTotal",
                    "BWTotal",
                    "revenueExtras",
                    // "bookingsCancelled",
                ].includes(e),
        ),
    ],
};
export const fields_OverviewTable_Vouchers = {
    fieldsOrder: ["vouchersCount", "revenueTotal", "voucherMin", "voucherMax"],
    hideFields: [
        ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
            (e) =>
                ![
                    "vouchersCount",
                    "vouchersBookings",
                    "revenueTotal",
                    "voucherMin",
                    "voucherMax",
                ].includes(e),
        ),
    ],
};

export const fields_FiltersTableReport = {
    fieldsOrder: [
        "revenueTotal",
        "revenueRoom",
        "revenueRoomAndExtras",
        "revenueExtras",
        "bookingsRooms",
        "roomNightsTotal",
        "bookingsCancelled",
        "empty",
        "ABWTotal",
        "ALoSTotal",
        "ADRTotal",
        "empty",
        "revenueVouchers",
        "vouchersBookings",
        "vouchersCount",
    ],
    hideFields: [
        ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
            (e) =>
                ![
                    "revenueTotal",
                    "revenueRoom",
                    "revenueRoomAndExtras",
                    "revenueExtras",
                    "bookingsRooms",
                    "roomNightsTotal",
                    "bookingsCancelled",
                    "revenueVouchers",
                    "ABWTotal",
                    "ALoSTotal",
                    "ADRTotal",
                    "vouchersBookings",
                    "vouchersCount",
                ].includes(e),
        ),
    ],
};

// TODO: Probably remove it from here as now it is copied in AroReportScreen.jsx
export const REPORTS = [
    {
        type: REPORT_TABLE_METRICS_SUMMARY,
        groupBy: [],
        ...fields_FiltersTableReport,
        PDF: "Metrics",
    },
    { type: BREAK_LINE, quantity: 1 },
    {
        type: TABS,
        default: "Rate Plan",
        tabs: [
            {
                type: TAB,
                title: "Rate Plan",
                reports: [
                    {
                        type: REPORT_CHART_BARS_CATEGORY,
                        title: "Rate Plan - Bar chart - 1",
                        groupBy: [GROUP_OFFERS],
                        metric: "bookingsTotal",
                        metrics: {
                            ...DISPLAY_ELEMENT_HELPER,
                            bookingsTotal: {
                                ...DISPLAY_ELEMENT_HELPER.bookingsTotal,
                                short: "Bookings total",
                            },
                        },
                    },
                    // {
                    //     type: GRID_HORIZONTAL,
                    //     spacing: 2,
                    //     reports: [
                    //         // {
                    //         //     type: REPORT_CHART_BARS_CATEGORY,
                    //         //     groupBy: [GROUP_OFFERS],
                    //         //     metric: "revenueTotal",
                    //         // },
                    //     ],
                    // },

                    {
                        type: REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
                        title: "Rate Plan - Trend chart - 1",
                        groupBy: [
                            GROUP_OFFERS,
                            GROUP_DATE_YEAR,
                            GROUP_DATE_MONTH,
                            GROUP_DATE_DAY,
                        ],
                        filters: { Types: ["Special Offer"] },
                        props: {
                            title: "Trend by rate plan",
                            showLastYear: false,
                            defaultBreakdown: "weekly",
                        },
                    },
                    {
                        type: REPORT_TABLE_OVERVIEW,
                        title: "Rate Plan - Overview table",
                        groupBy: [GROUP_OFFERS],
                        ...fields_OverviewTable,
                    },
                    // {
                    //     type: REPORT_TABLE_OVERVIEW,
                    //     groupBy: [GROUP_OFFERS],
                    // },
                ],
            },
            {
                type: TAB,
                title: "Room Type",
                reports: [
                    {
                        type: REPORT_CHART_BARS_CATEGORY,
                        title: "Room Type - Bar chart - 1",
                        groupBy: [GROUP_ROOM],
                        metric: "bookingsTotal",
                        metrics: {
                            ...DISPLAY_ELEMENT_HELPER,
                            bookingsTotal: {
                                ...DISPLAY_ELEMENT_HELPER.bookingsTotal,
                                short: "Bookings total",
                            },
                        },
                    },
                    // {
                    //     type: GRID_HORIZONTAL,
                    //     spacing: 2,
                    //     reports: [
                    //         // {
                    //         //     type: REPORT_CHART_BARS_CATEGORY,
                    //         //     groupBy: [GROUP_ROOM],
                    //         //     metric: "revenueTotal",
                    //         // },
                    //     ],
                    // },

                    {
                        type: REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
                        title: "Room Type - Trend chart - 1",

                        groupBy: [
                            GROUP_ROOM,
                            GROUP_DATE_YEAR,
                            GROUP_DATE_MONTH,
                            GROUP_DATE_DAY,
                        ],
                        filters: { Types: ["Special Offer"] },
                        props: {
                            title: "Trend by room type",
                            showLastYear: false,
                            defaultBreakdown: "weekly",
                        },
                    },
                    {
                        type: REPORT_TABLE_OVERVIEW,
                        title: "Room Type - Overview table",

                        groupBy: [GROUP_ROOM],
                        ...fields_OverviewTable,
                        sortable: [],
                    },
                    // {
                    //     type: REPORT_TABLE_OVERVIEW,
                    //     groupBy: [GROUP_ROOM],
                    // },
                ],
            },
            {
                type: TAB,
                title: "Geographical Market",
                reports: [
                    // {
                    //     type: GRID_HORIZONTAL,
                    //     reports: [
                    //         {
                    //             type: REPORT_CHART_BARS_CATEGORY,
                    //             groupBy: [GROUP_COUNTRIES],
                    //             metric: "bookingsTotal",
                    //         },
                    //         {
                    //             type: REPORT_CHART_BARS_CATEGORY,
                    //             groupBy: [GROUP_COUNTRIES],
                    //             metric: "revenueTotal",
                    //         },
                    //     ],
                    // },
                    {
                        type: REPORT_CHART_WORLD_MAP,
                        title: "Geographical Market - Map",
                        groupBy: [GROUP_COUNTRIES],
                        // ...fields_ChartMap,
                    },
                    {
                        type: REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
                        title: "Geographical Market - Trend chart - 1",
                        groupBy: [
                            GROUP_COUNTRIES,
                            GROUP_DATE_YEAR,
                            GROUP_DATE_MONTH,
                            GROUP_DATE_DAY,
                        ],
                        props: {
                            title: "Trend by country",
                            showLastYear: false,
                            defaultBreakdown: "weekly",
                        },
                    },
                    {
                        type: REPORT_TABLE_OVERVIEW,
                        title: "Geographical Market - Overview table",
                        groupBy: [GROUP_COUNTRIES],
                        ...fields_OverviewTable,
                    },
                ],
            },
            {
                type: TAB,
                isVoucher: true,
                title: "Vouchers",
                reports: [
                    {
                        type: REPORT_CHART_BARS_CATEGORY,
                        title: "Vouchers - Bar chart - 1",
                        groupBy: [GROUP_VOUCHERS],
                        metric: "vouchersCount",
                        metrics: Object.entries(DISPLAY_ELEMENT_HELPER).reduce(
                            (acc, [key, value]) => {
                                acc[key] =
                                    key === "revenueVouchers" ||
                                    key === "vouchersCount"
                                        ? {
                                              ...value,
                                              important: true,
                                              short:
                                                  "revenueVouchers" === key
                                                      ? "Revenue"
                                                      : "Number sold",
                                          }
                                        : {
                                              ...value,
                                              important: false,
                                          };
                                return acc;
                            },
                            {},
                        ),
                        filters: { Types: ["Voucher"] },
                        props: { showVouchers: true },
                    },
                    // {
                    //     type: GRID_HORIZONTAL,
                    //     spacing: 2,
                    //     reports: [
                    //     ],
                    // },
                    {
                        type: REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY,
                        title: "Vouchers - Trend chart - 1",
                        groupBy: [
                            GROUP_VOUCHERS,
                            GROUP_DATE_YEAR,
                            GROUP_DATE_MONTH,
                            GROUP_DATE_DAY,
                        ],
                        filters: { Types: ["Voucher"] },
                        props: {
                            showVouchers: true,
                            showLastYear: false,
                            defaultBreakdown: "weekly",
                            metrics: {
                                revenueVouchers: {
                                    ...DISPLAY_ELEMENT_HELPER.revenueVouchers,
                                    short: "Revenue",
                                },
                                vouchersCount: {
                                    ...DISPLAY_ELEMENT_HELPER.vouchersCount,
                                    short: "Number sold",
                                },
                            },
                        },
                    },
                    {
                        type: REPORT_TABLE_OVERVIEW,
                        title: "Vouchers - Overview table",
                        groupBy: [GROUP_VOUCHERS],
                        filters: { Types: ["Voucher"] },
                        props: { showVouchers: true },
                        ...fields_OverviewTable_Vouchers,
                    },
                    // {
                    //     type: REPORT_TABLE_OVERVIEW,
                    //     groupBy: [GROUP_TYPE],
                    // },
                    // {
                    //     type: REPORT_TABLE_OVERVIEW,
                    //     groupBy: [GROUP_VOUCHERS],
                    //     filters: { Types: ["Voucher"] },
                    // },
                ],
            },
        ],
    },

    //   _   _ _   _ _   _ ____  _____ ____
    //  | | | | \ | | | | / ___|| ____|  _ \
    //  | | | |  \| | | | \___ \|  _| | | | |
    //  | |_| | |\  | |_| |___) | |___| |_| |
    //   \___/|_| \_|\___/|____/|_____|____/

    // {
    //     type: ACTIVE_FILTERS_LINE,
    // },

    // {
    //     type: REPORT_CHART_LINES,
    //     groupBy: [
    //         GROUP_COUNTRIES,
    //         GROUP_DATE_YEAR,
    //         GROUP_DATE_MONTH,
    //         GROUP_DATE_DAY,
    //     ],
    // },

    // {
    //     type: CHART_BARS,
    //     groupBy: [
    //         GROUP_COUNTRIES,
    //         GROUP_DATE_YEAR,
    //         GROUP_DATE_MONTH,
    //         GROUP_DATE_DAY,
    //     ],
    // },

    //TODO: Voucher type with "filter" option
];

const ReportBuilder = ({
    PDF = false,
    reports = REPORTS,
    dataBookingsOverride = null,
    hotelIDOverride = null,
    onPDFItemsBuilt = null,
    headless = false,
}) => {
    const { id: hotelIDFromStore } = useSelector((state) => state.hotelID);
    const dataBookingsFromStore = useSelector((state) => state.dataBookings);
    const dataSimple = useSelector((state) => state.dataSimple);
    const dataTargets = useSelector((state) => state.dataTargets);

    const hotelID = hotelIDOverride ?? hotelIDFromStore;
    const dataBookings = dataBookingsOverride ?? dataBookingsFromStore;
    const js = useSelector((state) => state.globalReportFilters);

    const [processed, setProcessed] = useState({}); // TODO: Store here processed versions so we avoid recalculate them
    const [out, setout] = useState([]);
    const [update, setUpdate] = useState(1);

    const [loading, setLoading] = useState(true);

    const CalculateData = ({
        report,
        process = process_,
        jsOverrides = {},
    }) => {
        const dataBookingsToUse = report.dataBookingsOverride ?? dataBookings;

        const mergedFilters = report.filters
            ? { ...js.filters, ...report.filters }
            : js.filters;

        let js_ = {
            ...js,
            dataType: report.dataType ?? js.dataType,
            presetDate: report.presetDate ?? js.presetDate,
            fromDay: report.fromDay ?? js.fromDay,
            toDay: report.toDay ?? js.toDay,
            groupBy: report.groupBy ?? js.groupBy,
            filters: mergedFilters,
            fieldsOrder: report.fieldsOrder ?? js.fieldsOrder,
            hideFields: report.hideFields ?? js.hideFields,
            ...jsOverrides,
            filters: jsOverrides.filters
                ? { ...mergedFilters, ...jsOverrides.filters }
                : mergedFilters,
        };

        const jsKey = [
            dataBookingsToUse.hotelID,
            report.cacheKey ?? report.title ?? report.type,
            JSON.stringify(js_),
            dataBookingsToUse.status,
            dataBookingsToUse.updatedAt ?? "",
        ].join("|");

        if (processed[jsKey]) {
            return processed[jsKey];
        }

        let p = process({
            js: js_,
            dataBookings: dataBookingsToUse,
            hotelID,
            dataSimple,
            dataTargets,
        });

        const data = p.entries;
        const result = { data, js_ };

        setProcessed((prev) => ({ ...prev, [jsKey]: result }));
        return result;
    };

    //   ____  _____ _   _ ____  _____ ____
    //  |  _ \| ____| \ | |  _ \| ____|  _ \
    //  | |_) |  _| |  \| | | | |  _| | |_) |
    //  |  _ <| |___| |\  | |_| | |___|  _ <
    //  |_| \_\_____|_| \_|____/|_____|_| \_\
    const RenderReport = (report, key) => {
        const { data, js_ } = CalculateData({
            report,
            process: report.customProcess ?? process_,
        });
        if ((report.isVoucher ?? false) && !CheckHideBool("Vouchers", hotelID))
            return;

        switch (report.type) {
            case ACTIVE_FILTERS_LINE:
                return <ActiveFiltersLine key={key} />; // TODO: review with PDF

            case BREAK_LINE:
                return Array(report.quantity ?? 1)
                    .fill()
                    .map((_, idx) => <br key={`${key}-break-${idx}`} />);

            case GRID_HORIZONTAL: {
                const md =
                    report.md ??
                    (report.reports.length === 1
                        ? 12
                        : report.reports.length === 2
                          ? 6
                          : 4);

                const columns = 12 / md;

                return (
                    <Grid
                        key={key}
                        container
                        sx={(theme) => ({
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                sm: "1fr",
                                md: `repeat(${report.fullMd ? 1 : columns}, minmax(0, 1fr))`,
                                lg: `repeat(${columns}, minmax(0, 1fr))`,
                            },
                            gap: theme.spacing(report.spacing ?? 2),
                        })}
                    >
                        {report.reports.map((r, index) => (
                            <Grid
                                item
                                key={`key-${key}-${index}`}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    minWidth: 0,
                                }}
                            >
                                {RenderReport(
                                    r,
                                    report.reports.length > 1
                                        ? `${key} - ${index}`
                                        : key,
                                )}
                            </Grid>
                        ))}
                    </Grid>
                );
            }
            case TABS:
                return (
                    <TabsHelper
                        key={key}
                        defaultTab={report.default}
                        tabs={report.tabs.filter(
                            (tab) =>
                                !(
                                    !CheckHideBool("Vouchers", hotelID) &&
                                    (tab.isVoucher ?? false)
                                ),
                        )}
                        key_={key}
                    />
                );

            case REPORT_CHART_BARS_CATEGORY:
                return (
                    <ReportChartBarsCategory
                        key={key}
                        data={data}
                        initialMetric={report.metric ?? "bookingsTotal"}
                        metrics={report.metrics ?? DISPLAY_ELEMENT_HELPER}
                        groupBy={report.groupBy}
                        {...report.props}
                    />
                );

            case REPORT_CHART_LINES:
                return (
                    <ReportChartBarOrLines
                        key={key}
                        data={data}
                        js={js_}
                        chartType="line"
                        {...report.props}
                    />
                );

            case REPORT_CHART_BARS:
                return (
                    <ReportChartBarOrLines
                        key={key}
                        data={data}
                        js={js_}
                        chartType="bar"
                        {...report.props}
                    />
                );

            case REPORT_CHART_HEATMAP_CALENDAR:
                // TODO: Fix/Finish this component
                return (
                    <ReportHeatMapCalendar
                        key={key}
                        data={data}
                        js={js_}
                        {...report.props}
                    />
                );

            case REPORT_CHART_IN_TABLE:
                return (
                    <ReportChartInTable
                        key={key}
                        data={data}
                        js={js_}
                        {...report.props}
                    />
                );

            case REPORT_TABLE_METRICS_SUMMARY:
                return (
                    <ReportTableMetricsSummary
                        key={key}
                        data={data}
                        js={js_}
                        PDF={PDF}
                        processFn={report.customProcess ?? process_}
                        {...report.props}
                    />
                );

            case REPORT_TABLE_OVERVIEW:
                return (
                    <ReportTableOverview
                        key={key}
                        js={js_}
                        data={data}
                        PDF={PDF}
                        {...report.props}
                    />
                );

            case REPORT_TABLE_OVERVIEW_YEAR_MONTH:
                return (
                    <ReportTableOverviewYearMonth
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_TABLE_RESERVATIONS:
                return (
                    <ReportTableReservations
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_CHART_WORLD_MAP:
                return (
                    <ReportChartWorldMap
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY:
                return (
                    <ReportChartTrendDailyWeeklyMonthly
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_CHART_PERFORMANCE_VS:
                return (
                    <ReportChartPerformanceVS
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_PIE_CHART:
                return (
                    <ReportPieChart
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_CHART_CATEGORY_STACKED:
                return (
                    <ReportChartCategoryStacked
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_DAY_OF_THE_WEEK_TABLE:
                return (
                    <React.Fragment key={key}>
                        <ReportDayOfTheWeekTable
                            key={key}
                            js={js_}
                            data={data}
                            {...report.props}
                        />
                    </React.Fragment>
                );
            case REPORT_WEEKDAY_WEEKEND: {
                const comparison = report.secondaryDataType
                    ? CalculateData({
                          report,
                          process: report.customProcess ?? process_,
                          jsOverrides: {
                              dataType: report.secondaryDataType,
                          },
                      })
                    : null;

                return (
                    <ReportWeekdayWeekend
                        key={key}
                        js={js_}
                        data={data}
                        secondaryData={comparison?.data}
                        secondaryJs={comparison?.js_}
                        {...report.props}
                    />
                );
            }
            case REPORT_PIES_DISTRIBUTION_BY_RATE:
                return (
                    <ReportPiesDistributionByRate
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_WEEKDAY_RATES:
                return (
                    <ReportWeekdayRates
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_PIE_MIDWEEK_VS_WEEKEND:
                return (
                    <ReportPieMidweekVsWeekend
                        key={key}
                        js={js_}
                        data={data}
                        {...report.props}
                    />
                );
            case REPORT_METRIC_VS_METRIC_BARS:
                return (
                    <ReportMetricVSMetricBars
                        key={key}
                        data={data}
                        js={js_}
                        {...report.props}
                    />
                );
            case REPORT_METRIC_PIE:
                return (
                    <ReportMetricPie
                        key={key}
                        data={data}
                        js={js_}
                        {...report.props}
                    />
                );

            case REPORT_METRIC_LINE_TREND:
                return (
                    <ReportMetricLineTrend
                        key={key}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_TOP_DATES_TABLE:
                return (
                    <ReportTopDatesTable
                        key={key}
                        data={data}
                        {...report.props}
                    />
                );

            case REPORT_HOTEL_SUMMARY_TABLE:
                return (
                    <ReportHotelSummaryTable
                        key={key}
                        data={data}
                        js={js_}
                        {...report.props}
                    />
                );

            case CUSTOM: {
                const auxReport = report.render({ js: js_, hotelID, data });
                return <React.Fragment key={key}>{auxReport}</React.Fragment>;
            }

            default:
                break;
        }
    };

    //   _____  _    ____ ____
    //  |_   _|/ \  | __ ) ___|
    //    | | / _ \ |  _ \___ \
    //    | |/ ___ \| |_) |__) |
    //    |_/_/   \_\____/____/
    const TabsHelper = ({ getLoadedReports, defaultTab, tabs, key_ }) => {
        const [selected, setSelected] = useState(defaultTab);

        return (
            <>
                <Tabs
                    value={selected}
                    onChange={(e, newV) => {
                        setSelected(newV);
                    }}
                    sx={{
                        borderBottom: 1,
                        borderColor: Colours.navbarBottomLine,
                    }}
                >
                    {tabs.map((t) => {
                        if (
                            !CheckHideBool("Vouchers", hotelID) &&
                            (t.isVoucher ?? false)
                        )
                            return;
                        else
                            return (
                                <Tab
                                    label={t.title}
                                    key={t.title}
                                    value={t.title}
                                />
                            );
                    })}
                </Tabs>
                {tabs
                    .filter((t) => t.title === selected)
                    .map((tab, tabIdx) => (
                        <div key={`${key_}-tab-${tabIdx}`}>
                            <Stack spacing={1} direction={"column"}>
                                {tab.reports.map((subReport, subKey) =>
                                    RenderReport(
                                        subReport,
                                        `${key_}-${tabIdx}-${subKey}`,
                                    ),
                                )}
                            </Stack>
                        </div>
                    ))}
            </>
        );
    };

    useEffect(() => {
        if (dataBookings.status === "loading") {
            setLoading(true);
            setProcessed({});
        }

        if (
            Object.keys(js).length > 0 &&
            (dataBookings.status === "loaded" ||
                dataBookings.status === "partiallyLoaded")
        ) {
            setLoading(false);
            let aux_out = [];

            const buildPDFItem = (report, index) => {
                switch (report.type) {
                    case REPORT_CHART_BARS_CATEGORY:
                    case REPORT_CHART_TREND_DAILY_WEEKLY_MONTHLY: {
                        console.log({ report });
                        const title =
                            report.title ??
                            report.props?.title ??
                            `Report ${index + 1}`;
                        return {
                            jsx: RenderReport(report, index),
                            title,
                            key: title,
                            options: {
                                duplicable: report.options?.duplicable ?? true,
                            },
                        };
                    }

                    case REPORT_TABLE_METRICS_SUMMARY: {
                        const title =
                            report.title ?? report.props?.title ?? "Summary";
                        return {
                            jsx: RenderReport(report, index),
                            title,
                            key: title,
                            options: { duplicable: false },
                        };
                    }

                    case GRID_HORIZONTAL: {
                        const children = report.reports
                            .flatMap((r, subIndex) => {
                                const result = buildPDFItem(
                                    r,
                                    `${index}-${subIndex}`,
                                );
                                return Array.isArray(result)
                                    ? result
                                    : [result];
                            })
                            .filter(Boolean);
                        return children;
                    }

                    case TABS: {
                        const visibleTabs = report.tabs.filter(
                            (tab) =>
                                !(
                                    !CheckHideBool("Vouchers", hotelID) &&
                                    (tab.isVoucher ?? false)
                                ),
                        );
                        return visibleTabs.flatMap((tab, tabIdx) => {
                            const groupId = `${index}-tab-${tabIdx}`;
                            const children = tab.reports
                                .flatMap((r, subIndex) => {
                                    const result = buildPDFItem(
                                        r,
                                        `${index}-${tabIdx}-${subIndex}`,
                                    );
                                    return Array.isArray(result)
                                        ? result
                                        : [result];
                                })
                                .filter(Boolean)
                                .map((c) => {
                                    const isDuplicable =
                                        c.options?.duplicable ?? false;
                                    const shortTitle = c.title ?? c.key;
                                    const qualifiedBase = `${tab.title} - ${shortTitle}`;
                                    const qualifiedTitle = isDuplicable
                                        ? `${qualifiedBase} - 1`
                                        : qualifiedBase;
                                    const displayTitle = isDuplicable
                                        ? `${shortTitle} - 1`
                                        : shortTitle;
                                    return {
                                        ...c,
                                        title: qualifiedTitle,
                                        key: qualifiedTitle,
                                        options: {
                                            ...c.options,
                                            groupId,
                                            displayTitle,
                                        },
                                    };
                                });
                            return [
                                {
                                    jsx: (
                                        <Typography
                                            variant="h6"
                                            fontWeight="bold"
                                            sx={{
                                                pb: 0.5,
                                                borderBottom: "2px solid #eee",
                                            }}
                                        >
                                            {tab.title}
                                        </Typography>
                                    ),
                                    title: `${tab.title} Tab`,
                                    key: `${tab.title} Tab`,
                                    options: {
                                        isGroupHeader: true,
                                        groupId,
                                        groupTitle: tab.title,
                                        duplicable: false,
                                    },
                                },
                                ...children,
                            ];
                        });
                    }

                    default: {
                        const title =
                            report.title ??
                            report.props?.title ??
                            `Report ${index + 1}`;
                        return {
                            jsx: RenderReport(report, index),
                            title,
                            key: title,
                            options: {
                                duplicable: false,
                                ...(report.options ?? {}),
                            },
                        };
                    }
                }
            };

            const pdfItemsToCallback = [];
            reports.forEach((r, index) => {
                if (!headless) aux_out.push(RenderReport(r, index));
                if (onPDFItemsBuilt) {
                    const pdfItems = buildPDFItem(r, index);
                    if (pdfItems) {
                        (Array.isArray(pdfItems)
                            ? pdfItems
                            : [pdfItems]
                        ).forEach((item) => {
                            pdfItemsToCallback.push({
                                id: item.title,
                                title: item.title,
                                element: item.jsx,
                                options: item.options,
                            });
                        });
                    }
                }
            });

            if (onPDFItemsBuilt) {
                onPDFItemsBuilt(pdfItemsToCallback);
            }

            setout(() => aux_out);
            setUpdate(update + 1);
        }
    }, [js, reports, hotelID, dataBookings, dataSimple]);

    //   ____  _  _______ _     _____ _____ ___  _   _
    //  / ___|| |/ / ____| |   | ____|_   _/ _ \| \ | |
    //  \___ \| ' /|  _| | |   |  _|   | || | | |  \| |
    //   ___) | . \| |___| |___| |___  | || |_| | |\  |
    //  |____/|_|\_\_____|_____|_____| |_| \___/|_| \_|
    if (headless) return null;

    if (loading) {
        return (
            <Stack spacing={1}>
                <Skeleton variant="rounded" height={230} />
                <Skeleton variant="rounded" height={400} />
                <Skeleton variant="text" height={75} />
                <Skeleton variant="rounded" height={250} />
                <Skeleton variant="text" height={75} />
                <Skeleton variant="rounded" height={500} />
            </Stack>
        );
    }

    if (out.length > 0) {
        return (
            <Stack spacing={1} key={update}>
                {out}
            </Stack>
        );
    }

    return null;
};

export default ReportBuilder;
